import { call, put, takeLatest } from 'redux-saga/effects';
import apiCall from '../helpers/ApiCall';
import { GET } from '../consts/Methods';
import apiRoot from '../consts/apiRoot';
import { FETCH_OFFERS_DETAILS, FETCH_OFFERS_DETAILS_SUCCESS, FETCH_OFFERS_DETAILS_FAIL } from '../redux/OffersDetails';

function* getOfferDetailsFlow({ payload: offerId, }) {
  try {
    const endpoint = `${apiRoot}/offers/${offerId}`;
    const offerDetails = yield call(apiCall, { method: GET, endpoint, });
    yield put(FETCH_OFFERS_DETAILS_SUCCESS(offerDetails));
  } catch (error) {
    yield put(FETCH_OFFERS_DETAILS_FAIL(error));
  }
}

export default function* GetOfferDetails() {
  yield takeLatest(FETCH_OFFERS_DETAILS, getOfferDetailsFlow);
}
